<template>
  <div class="message-input"
    ref="typer"
    contenteditable="true"
    v-html="innerText"
    v-ios-bug-fixed
    @input="changeText"
    @focus="inputFocus"
    @blur="isLocked = false"></div>
</template>

<style lang="less" scoped>
  .message-input{
    width: 100%;
    line-height: 20px;
    padding: 10px 12px;
    color: #666;
    border: 0;
    word-break: break-all;
    background: #F3F3F3;
    border-radius: 20px;
    transition: all .2s;
    outline: none;
    max-height: 80px;
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>

<script type="text/javascript">
  export default {
    props: {
      value: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        // 默认值必须为一个空格，否则会出现第一个字母漂移的问题
        innerText: ' ',
        isLocked: false
      }
    },
    watch: {
      'value'() {
        if (!this.isLocked || !this.innerText) {
          this.innerText = this.value;
        }
      }
    },
    // mounted() {
    //   window.addEventListener('focusout', this.fixScrollTop);
    // },
    // beforeDestory() {
    //   window.removeEventListener('focusout', this.fixScrollTop);
    // },
    methods: {
      changeText() {
        this.$emit('input', this.$el.innerHTML);
      },
      inputFocus() {
        this.isLocked = true;
        this.$emit('focus', this.$el.innerHTML);
      },
      // 消除输入第一个字母光标漂移的问题
      clearComponentText() {
        this.innerText = ' ';
      },
      // fixScrollTop() {
      //   setTimeout(() => {
      //     document.body.scrollTop = document.body.scrollHeight
      //   }, 100)
      // }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/flexibleTextInput.vue